import PracticePlay from './component';

export default () => ({
  path: 'practice-play',
  component: PracticePlay,
});



// WEBPACK FOOTER //
// ./containers/Group/Homework/PracticePlay/routes.js